import React from "react";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";

import Heading from "core/Heading";

import { MaterialUIGridContainer } from "core/MaterialUI";
import colors from "core/colors";
import { BulletGridHeading, BulletIcon, Paragraph } from "./styles";

const Content = ({ bullets, sectionHeading, sectionHeadingColor }) => (
    <>
        {sectionHeading && (
            <Heading
                headingColor={sectionHeadingColor}
                type="h2"
                size="xl"
                bottomSpacing="4xl"
                alignment="center"
            >
                {sectionHeading}
            </Heading>
        )}
        <MaterialUIGridContainer
            key={sectionHeading}
            mobileMaxPadding={9}
            // passing in index 9 passes in the number "48" from the spacing array divided by 2 = 48px gutter as 24px around each item (see line 9 of core/MaterialUI/ for this spacing array)
            tabletMaxPadding={4}
            // passing in index 4 passes in the number "20" from the spacing array divided by 2 = 20px gutter as 10px around each item (see line 9 of core/MaterialUI/ for this spacing array)
            desktopMinPadding={9}
            // passing in index 9 passes in the number "48" from the spacing array divided by 2 = 48px gutter as 24px around each item (see line 9 of core/MaterialUI/ for this spacing array)
        >
            {bullets.map(bullet => (
                <Grid item sm={12} md={4} lg={4} key={bullet.title}>
                    {bullet.icon && <BulletIcon>{bullet.icon}</BulletIcon>}
                    <BulletGridHeading
                        headingColor={colors.secondary.orca}
                        type="h6"
                        size="xs"
                    >
                        {bullet.title}
                    </BulletGridHeading>
                    <Paragraph>{bullet.text}</Paragraph>
                </Grid>
            ))}
        </MaterialUIGridContainer>
    </>
);

Content.propTypes = {
    bullets: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.element,
            title: PropTypes.string,
            text: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
        })
    ).isRequired,
    sectionHeading: PropTypes.string
};

export default Content;
